/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Casmanagement_Table_Inactive1Inputs */

const en_settings_casmanagement_table_inactive1 = /** @type {(inputs: Settings_Casmanagement_Table_Inactive1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactive`)
};

/**
* | output |
* | --- |
* | "Inactive" |
*
* @param {Settings_Casmanagement_Table_Inactive1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_casmanagement_table_inactive1 = /** @type {((inputs?: Settings_Casmanagement_Table_Inactive1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Casmanagement_Table_Inactive1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_casmanagement_table_inactive1(inputs)
});
export { settings_casmanagement_table_inactive1 as "settings_casManagement_table_inactive" }